import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedAuditor } from 'contracts/Auditors';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_AUDITORS_',
  }
);

export interface ListAuditorsState {
  data: ListedAuditor[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListAuditorsRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedAuditor[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListAuditorsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListAuditorsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListAuditorsState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListAuditorsState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListAuditorsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listAuditors = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListAuditorsTypes = Types;
export const ListAuditorsActions = Creators;
